import data from "../assets/data/questionsForFAQ";

export const useFAQData = () => {
    return data;
}